module.exports = __webpack_public_path__ + "img/sign-tl.e27e6a84.png";